import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "plate-header" }
const _hoisted_2 = { class: "plate-title" }
const _hoisted_3 = { class: "plate-stamp bg-msq-yellow" }
const _hoisted_4 = { class: "trace-run" }
const _hoisted_5 = { class: "trace-run-row" }
const _hoisted_6 = { class: "trace-status" }
const _hoisted_7 = { class: "trace-run-meta text-disabled" }
const _hoisted_8 = { class: "trace-sub-head text-disabled" }
const _hoisted_9 = { class: "trace-agents" }
const _hoisted_10 = { class: "ta-name" }
const _hoisted_11 = { class: "ta-tok text-disabled" }
const _hoisted_12 = {
  key: 0,
  class: "ta-detail"
}
const _hoisted_13 = {
  key: 0,
  class: "ta-report"
}
const _hoisted_14 = { class: "ta-report-h" }
const _hoisted_15 = { class: "text-medium-emphasis" }
const _hoisted_16 = { class: "trace-main" }
const _hoisted_17 = { class: "trace-main-h text-disabled" }
const _hoisted_18 = { class: "plate-cap text-disabled" }
const _hoisted_19 = { class: "plate-foot text-disabled" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ToolCallRow = _resolveComponent("ToolCallRow")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      class: "plate",
      color: "surface",
      rounded: "lg",
      variant: "flat",
      elevation: "4"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.stamp), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_v_icon, {
                icon: "mdi-check-circle",
                size: "18",
                color: "accent-green"
              }),
              _cache[0] || (_cache[0] = _createTextVNode(" Workflow Run "))
            ]),
            _createElementVNode("span", _hoisted_7, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "pill" }, "completed", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.runMeta), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, "Sub-agents (" + _toDisplayString(_ctx.agents.length) + "/" + _toDisplayString(_ctx.agents.length) + ")", 1),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agents, (agent) => {
            return (_openBlock(), _createElementBlock("div", {
              key: agent.name,
              class: "ta"
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isExpandable(agent) ? 'button' : 'div'), {
                class: _normalizeClass(["ta-row", { 'ta-row--static': !_ctx.isExpandable(agent) }]),
                type: _ctx.isExpandable(agent) ? 'button' : undefined,
                "aria-expanded": _ctx.isExpandable(agent) ? String(!!_ctx.expanded[agent.name]) : undefined,
                onClick: ($event: any) => (_ctx.isExpandable(agent) && _ctx.toggle(agent.name))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_v_icon, {
                      icon: "mdi-check-circle",
                      size: "15",
                      color: "accent-green"
                    }),
                    _createTextVNode(" " + _toDisplayString(agent.name), 1)
                  ]),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(agent.tokens), 1),
                  (_ctx.isExpandable(agent))
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        icon: "mdi-chevron-down",
                        size: "18",
                        class: _normalizeClass(["ta-caret text-disabled", { 'ta-caret--collapsed': !_ctx.expanded[agent.name] }])
                      }, null, 8, ["class"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["class", "type", "aria-expanded", "onClick"])),
              (_ctx.isExpandable(agent) && _ctx.expanded[agent.name])
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agent.toolCalls, (call, ci) => {
                      return (_openBlock(), _createBlock(_component_ToolCallRow, {
                        key: ci,
                        call: call,
                        "initially-expanded": !!call.json
                      }, null, 8, ["call", "initially-expanded"]))
                    }), 128)),
                    (agent.reportHeadline)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(agent.reportHeadline), 1),
                          _createElementVNode("p", _hoisted_15, _toDisplayString(agent.reportText), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Main agent output", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.mainTokens), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.mainText), 1)
        ]),
        _createElementVNode("p", _hoisted_18, [
          _createVNode(_component_v_icon, {
            icon: "mdi-information-outline",
            size: "15",
            class: "plate-cap__icon"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.disclaimer), 1)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.foot), 1)
  ]))
}